import React, { useEffect } from "react";
import { toast } from "react-toastify";

interface Props {
    email: string;
    amount: number | string;
    slug: string
    onSuccess: () => void;
}

const PaystackButton: React.FC<Props> = ({
    email,
    amount,
    slug,
    onSuccess }) => {

        console.log("Amount: ", amount);

        useEffect(() => {
            if(!(window as any).PaystackPop) {
                const script = document.createElement('script');
                script.src = 'https://js.paystack.co/v1/inline.js';
                script.async = true;
                document.body.appendChild(script);
            }
        }, []);
        
        const ref = `StorePilot-${slug.replaceAll(" ", "_").toLowerCase()}-${Date.now()}`;

        const handlePayment = () => {
            const handler = (window as any).PaystackPop.setup({
            key: import.meta.env.VITE_LIVE_PAYSTACK_STRING, 
            email: email,      
            amount: Number(amount) * 100, 
            currency: 'GHS',
            ref,
            metadata: {
                custom_fields: [
                     {
                        display_name: "Subscription",
                        variable_name: "subscription",
                        value: slug,
                    }
                ]
            },
            callback: (response: any) => {
                toast.success('Payment complete! Reference: ' + response.reference);
                onSuccess();
            },
            onClose: () => {
                toast.error('Transaction was not completed, window closed.');
            },
            });

            handler.openIframe();
        };

        return (
            <button
                type="button"
                onClick={handlePayment}
                className="form-btn-mini w-full"
            >
                Confirm Subscription
            </button>
        );
}
 
export default PaystackButton;